(() => {
  if (window.saMaskFeaturesInitialized) return;
  window.saMaskFeaturesInitialized = true;

  const alignTypography = (root = document) => {
    root.querySelectorAll('.sa-mask-details__app-item [id="subheading"]').forEach((subheading) => {
      subheading.style.removeProperty('font-size');
      subheading.style.removeProperty('color');
    });
    root.querySelectorAll('.sa-mask-details__app-item [data-banner]').forEach((banner) => {
      banner.style.removeProperty('margin-top');
      banner.style.removeProperty('margin-bottom');
    });
    root.querySelectorAll('.sa-mask-details__app-item [id="title"]').forEach((title) => {
      title.style.removeProperty('font-weight');
    });
  };
  const syncStrap = (features) => {
    const optionName = features.dataset.strapOption;
    if (!optionName) return;
    const scope = features.closest('product-info') || features.closest('.shopify-section');
    const picker = scope?.querySelector('variant-selects');
    if (!picker) return;
    const group = Array.from(picker.querySelectorAll('[data-option-name]')).find((node) =>
      node.matches('fieldset, .product-form__input--dropdown') && node.dataset.optionName === optionName
    );
    const selection = group?.querySelector('input:checked, select');
    if (!selection) return;
    const rope = selection.value.toLowerCase().includes('straw rope');
    features.querySelectorAll('[data-strap-feature]').forEach((row) => {
      row.hidden = (row.dataset.strapFeature === 'rope') !== rope;
    });
  };
  const syncAll = () => document.querySelectorAll('[data-mask-features]').forEach(syncStrap);
  alignTypography();
  syncAll();
  document.addEventListener('change', (event) => {
    if (event.target.closest?.('variant-selects')) syncAll();
  });
  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
    subscribe(PUB_SUB_EVENTS.variantChange, syncAll);
  }
  new MutationObserver((records) => {
    for (const record of records) {
      for (const node of record.addedNodes) {
        if (node.nodeType === 1) alignTypography(node.closest('.sa-mask-details__app-item') || node);
      }
    }
  }).observe(document.body, { childList: true, subtree: true });
})();
